require('./RAReimbursementModal.scss');
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

class RAReimbursementModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleLink = this.handleLink.bind(this);
    }

    handleLink(url) {
        const { cancelModifyPlanModal, history } = this.props;
        history.push(url);
        cancelModifyPlanModal();
    }

    render() {
        const {
            showModal,
            modalUrl,
            modalData,
            closeModal,
            isTestExpired,
        } = this.props;

        const modalLink = (
            <OKLink onClick={() => this.handleLink(modalUrl)}>
                <FormattedText value={modalData.linkText} />
            </OKLink>
        );

        const modalContent = modalData.content3 ? (
            <div className="ra-reimbursement-modal__content">
                <FormattedText
                    value={modalData.content1}
                    className="ra-reimbursement-modal__text"
                />
                {!isTestExpired && (
                    <FormattedTextWithComponents
                        className="ra-reimbursement-modal__text"
                        value={modalData.content2}
                        injectedComponents={[modalLink]}
                    />
                )}
                <FormattedText
                    value={modalData.content3}
                    className="ra-reimbursement-modal__text"
                />
            </div>
        ) : (
            <div className="ra-reimbursement-modal__content">
                {!isTestExpired && (
                    <FormattedTextWithComponents
                        value={modalData.content1}
                        className="ra-reimbursement-modal__text"
                        injectedComponents={[modalLink]}
                    />
                )}
                <FormattedText
                    value={modalData.content2}
                    className="ra-reimbursement-modal__text"
                />
            </div>
        );

        const modalButton = (
            <OKButton onClick={closeModal}>
                <FormattedText value={modalData.buttonText} />
            </OKButton>
        );
        return (
            <OKModal
                title={formatText(modalData.title)}
                titleAlignment="center"
                content={modalContent}
                footerType="action"
                isOpen={showModal}
                onPrimaryButtonClick={closeModal}
                onCloseCallback={closeModal}
                primaryButtonCustom={modalButton}
            />
        );
    }
}

RAReimbursementModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    modalUrl: PropTypes.string.isRequired,
    modalData: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    cancelModifyPlanModal: PropTypes.func.isRequired,
    isTestExpired: PropTypes.bool.isRequired,
};

module.exports = withRouter(RAReimbursementModal);
